import {wp_social} from '../api';

const getSocialLoginWpUser = (googleResponse) => async (dispatch) => {
    console.log(googleResponse);
    const wp_response = await fetch( wp_social(), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            social_type: 'google',
            social_user_token: googleResponse.tokenObj ? googleResponse.tokenObj.id_token : '',
            perm_id: googleResponse ? googleResponse.googleId : '',
        }),
    })

    let data = await wp_response.json();

    if ( data && data[0] ) {
        data = data[0]
    }

    // If we did auth
    if ( data.data && data.data.login && data.data.login.user.jwtAuthToken ) {
        dispatch({
            type : 'USER_LOGGED_IN',
            payload : data.data.login.user,
        })
    }

    // If we didn't authenitcate
    if ( data.errors ) {
        let message = 'Failed to Authenticate';
        if ( data.errors.code ) {
            message = data.errors.message;
        }

        dispatch({
            type : 'FAILED_USER_LOG_IN',
            payload : [
                message
            ],
        })
    }
}

export default getSocialLoginWpUser;